import React from "react";
import ReactPlayer from "react-player/youtube";

function About() {
  return (
    <div className="container">
      <h2 className="mt-5" style={{ fontWeight: 600 }}>
        About Us
      </h2>
      <div className="row mt-3">
        <div className="col-12 col-md-12 col-lg-6 mt-2">
          <ReactPlayer className="w-100 " controls="true" url="https://www.youtube.com/watch?v=ZjrMWKimh2w" />
        </div>
        <div className="col-12 col-md-12 col-lg-6 mt-4">
          <h4 style={{ fontWeight: 600 }}>useMango allows you to create Fast. Automated. Codeless. Testing... and that's a F.A.C.T!</h4>
          <h5 style={{ fontWeight: 600 }} className="mb-2 mt-4">
            Start your Test Automation journey the right way
          </h5>
          <p>
            <ul className="aboutcontent">
              <li> Easy to use Test Automation tool - get up and running in under a week</li>
              <li> Stop inconsistant, unscalable test automation approaches built by individuals</li>
              <li> Avoid the costs of engineering your own high maintenance frameworks</li>
            </ul>
          </p>
        </div>
      </div>
      <div className="d-flex flex-column align-items-center justify-content-center mt-5">
        <h4 style={{ fontWeight: 600 }}>Start your free trial now!</h4>
        <a href="https://www.usemango.co.uk/usemango-free-trial">
          <button className="btn btn-outline-dark btn-lg mt-3 mb-4">Click to Begin</button>
        </a>
      </div>
    </div>
  );
}
export default About;
